export default function (x) {
  return function () {
    return x;
  };
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/d3-transition/node_modules/d3-interpolate/src/constant.js
// module id = 451
// module chunks = 0